/**
 * FichaHerramienta — la ficha de una herramienta. Se abre desde una tarjeta de
 * «Herramientas». La puerta real es GET /v1/herramientas/{id} (solo admin).
 *
 * GEN-TL-002: nombre, descripción en lenguaje llano y sobre qué actúa.
 * GEN-TL-003: los niveles de acceso, ordenados de menos a más, cada uno con
 * su frase; una herramienta de un solo nivel muestra ese único nivel.
 * GEN-TL-004: Motor n8n se ve como UNA ficha con sus 8 niveles, en orden.
 * GEN-TL-005: el nivel que pide confirmación de una persona antes de actuar
 * lleva un chip visible («Pide confirmación»); los que no la piden, ninguno.
 * GEN-TL-007: qué agentes tienen la herramienta y con qué nivel (solo lectura).
 */

import { useEffect, useState } from 'react'
import { getHerramienta } from '../api/client.js'
import AgentesDeLaHerramienta from './AgentesDeLaHerramienta.jsx'

export default function FichaHerramienta({ herramientaId, onVolver }) {
  const [datos, setDatos] = useState(null)

  useEffect(() => {
    let vivo = true
    getHerramienta(herramientaId)
      .then(d => vivo && setDatos(d))
      .catch(() => vivo && setDatos({ error: 'No se ha podido cargar la ficha.' }))
    return () => { vivo = false }
  }, [herramientaId])

  return (
    <section className="mec-visor">
      <button type="button" className="ficha-volver" onClick={onVolver}>← Herramientas</button>
      {!datos && <p className="equipo-estado">Cargando…</p>}
      {datos?.error && <p className="equipo-estado" role="alert">{datos.error}</p>}
      {datos && !datos.error && (
        <div className="ficha-lectura__tarjetas">
          <section className="ficha-card ficha-card--cabecera">
            <h2>{datos.nombre}</h2>
            <p className="ficha-card__texto">{datos.descripcion}</p>
          </section>
          <section className="ficha-card">
            <h3 className="ficha-card__titulo">Sobre qué actúa</h3>
            <p className="ficha-card__texto">{datos.actua_sobre}</p>
          </section>
          <section className="ficha-card">
            <h3 className="ficha-card__titulo">Niveles de acceso</h3>
            <ol className="niveles-lista">
              {datos.niveles.map((nivel, i) => (
                <li key={i} className="niveles-lista__item">
                  <span className="niveles-lista__cabecera">
                    <span className="niveles-lista__nombre">{nivel.nombre}</span>
                    {nivel.pide_confirmacion && (
                      <span className="equipo-chip equipo-chip--confirmacion">Pide confirmación</span>
                    )}
                  </span>
                  <p className="ficha-card__texto">{nivel.frase}</p>
                </li>
              ))}
            </ol>
          </section>
          <AgentesDeLaHerramienta herramientaId={herramientaId} />
        </div>
      )}
    </section>
  )
}
